export enum PaginationType {
    SCROLL = 'scroll',
    PAGE = 'page'
}


export enum LAYOUT_TYPE {
    Layout_01 = 'Layout_01',
    Layout_02 = 'Layout_02',
    Layout_03 = 'Layout_03'
}

export enum VariantAttribute {
    Color = 'Color'
}

export enum BannerType {
    Banner_01 = 'Banner_01',
    Banner_02 = 'Banner_02',
    Banner_03 = 'Banner_03',
    Banner_04 = 'Banner_04',
    Carousel_layout = 'Carousel_layout'
}

export enum MOBILE_GRID_LAYOUT {
    GRID_LAYOUT1 = "gridLayout1",
    GRID_LAYOUT2 = "gridLayout2",
}
